import { Link } from "react-router-dom";
import { useContent } from "@/contexts/ContentContext";

export default function Footer() {
  const { content } = useContent();

  return (
    <footer className="bg-[#091526] text-[#F4F4F5] mt-32" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16 py-20">
        <div className="border-b border-[#F4F4F5]/20 pb-12 mb-12">
          <h2
            className="font-display text-5xl sm:text-7xl lg:text-8xl leading-none uppercase"
            data-testid="footer-tagline"
          >
            {content.footer_tagline}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-2">
            <div className="h-20 w-32 border-2 border-[#F4F4F5] bg-white flex items-center justify-center p-1">
              <img
                src="/images/logo.png"
                alt="Pile Glide Pro"
                className="max-h-full max-w-full object-contain"
              />
            </div>
          </div>

          <div className="md:col-span-2">
            <h4 className="font-mono text-xs uppercase tracking-[0.2em] font-semibold text-[#1E5BB8] mb-4">
              Navigate
            </h4>
            <ul className="space-y-2">
              <li><Link to="/" className="hover:text-[#1E5BB8] transition-colors">Home</Link></li>
              <li><Link to="/product" className="hover:text-[#1E5BB8] transition-colors">Product</Link></li>
              <li><Link to="/contact" className="hover:text-[#1E5BB8] transition-colors">Contact</Link></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="font-mono text-xs uppercase tracking-[0.2em] font-semibold text-[#1E5BB8] mb-4">
              Location
            </h4>
            <ul className="space-y-2 text-sm">
              <li data-testid="footer-location">Charleston, SC</li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-mono text-xs uppercase tracking-[0.2em] font-semibold text-[#1E5BB8] mb-4">
              Contact
            </h4>
            <ul className="space-y-2 text-sm">
              <li data-testid="footer-email" className="whitespace-nowrap">{content.contact_email}</li>
              {content.contact_address && (
                <li data-testid="footer-address" className="leading-relaxed">{content.contact_address}</li>
              )}
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-mono text-xs uppercase tracking-[0.2em] font-semibold text-[#1E5BB8] mb-4">
              Sizes
            </h4>
            <ul className="space-y-2 font-mono text-sm">
              <li>10 INCH</li>
              <li>12 INCH</li>
              <li>14 INCH</li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-[#F4F4F5]/20 flex flex-col md:flex-row justify-between gap-4 text-xs font-mono uppercase tracking-[0.2em] text-[#F4F4F5]/50">
          <span>© {new Date().getFullYear()} Pile Glide Pro</span>
        </div>
      </div>
    </footer>
  );
}
